import React, { Component } from 'react';
import styled from 'styled-components';

import css from 'css';
import WP from 'WP';
import SmartLink from 'partials/SmartLink';
import Image from 'partials/Image';

class SearchResults extends Component {

    _onResultClick() {
        if(this.props.onResultClick) {
            this.props.onResultClick();
        }
    }

    render() {
        const { searchResults, searching, searchQuery } = this.props;

        if(searching)
            return (
                <SearchResultsWrapper>
                    <span className="searching">....</span>
                </SearchResultsWrapper>
            );

        if(searchResults.count === 0 && !searching && searchQuery !== '') 
            return (
                <SearchResultsWrapper>
                    <span className="nothing-found">{WP.trans.nothingFound}</span>
                </SearchResultsWrapper>
            );

        if(searchQuery !== '') {
            return (
                <SearchResultsWrapper>
                    <div className="results-wrapper">
                        <span className="res-count">{searchResults.count} {WP.trans.results}</span>

                        <Columns>

                            {searchResults.results.projects[0] &&
                                <Column>
                                    <span className="section-name">{WP.trans.projects}</span>
                                    {searchResults.results.projects.map(post => {
                                        return (
                                            <div className="item project" key={post.ID} >
                                                <SmartLink onClick={this._onResultClick.bind(this)} className="title" to={post.permalink}>{post.post_title}</SmartLink>
                                                <SmartLink onClick={this._onResultClick.bind(this)} to={post.permalink}>
                                                    <Image image={post.featured_image_src} className="image" background ratio="16:9" />
                                                </SmartLink>
                                                {post.category_info[0] && 
                                                    <div className="meta">
                                                        {WP.trans.category}
                                                        <span>{post.category_info[0].name}</span>
                                                    </div>
                                                }
                                            </div>
                                        );
                                    })}
                                </Column>
                            }

                            {searchResults.results.post[0] &&
                                <Column>
                                    <span className="section-name">{WP.trans.news}</span>
                                    {searchResults.results.post.map(post => {
                                        return (
                                            <div className="item news" key={post.ID} >
                                                <SmartLink onClick={this._onResultClick.bind(this)} className="title" to={post.permalink}>{post.post_title}</SmartLink>
                                                <SmartLink onClick={this._onResultClick.bind(this)} to={post.permalink}>
                                                    <Image image={post.featured_image_src} className="image" background ratio="16:9" />
                                                </SmartLink>
                                                {post.category_info[0] && 
                                                    <div className="meta">
                                                        {WP.trans.category}
                                                        <span>{post.category_info[0].name}</span>
                                                    </div>
                                                }
                                            </div>
                                        );
                                    })}
                                </Column>
                            }

                            <Column>

                                {searchResults.results.page[0] && <span className="section-name">{WP.trans.pages}</span> }
                                {searchResults.results.page.map(post => {
                                    return (
                                        <div className="item" key={post.ID} >
                                            <SmartLink onClick={this._onResultClick.bind(this)} className="title" to={post.permalink}>{post.post_title}</SmartLink>
                                        </div>
                                    );
                                })}

                                {searchResults.results.tours[0] && <span className="section-name">{WP.trans.tours}</span> }
                                {searchResults.results.tours.map(post => {
                                    return (
                                        <div className="item" key={post.ID} >
                                            <SmartLink onClick={this._onResultClick.bind(this)} className="title" to={post.permalink}>{post.post_title}</SmartLink>
                                        </div>
                                    );
                                })}

                                {searchResults.results.employees[0] && <span className="section-name">{WP.trans.employees}</span> }
                                {searchResults.results.employees.map(post => {
                                    return (
                                        <div className="item employee" key={post.ID} >
                                            <div className="title" >{post.post_title}</div>
                                            <div className="meta">
                                                <span>{post.acf.job_title}</span>
                                                <span><a href={'mailto:'+post.acf.email}>{post.acf.email}</a> / <a href={'tel:'+post.acf.phone.replace(' ','')}>{post.acf.phone}</a></span>
                                            </div>                                            
                                        </div>
                                    );
                                })}
                                
                            </Column>
                        </Columns>
                    </div>
                </SearchResultsWrapper>
            )
        }

        return <div/>
    }
}

export default SearchResults;

const SearchResultsWrapper = styled.div`
    position: fixed;
    top: 0;
    max-width: 1250px;
    width: 100%;
    height: 100%;
    z-index: 100;
    padding-top: 120px;
    left: 50%;
    transform: translateX(-50%);

    @media (max-width: 1252px) {
        padding: 120px 25px 0;
    }

    @media (max-width: 768px) {
        position: relative;
        top:auto;
        width:100%;
        height:auto;
        padding: 0;
    }
    
    .nothing-found, .res-count, .searching {
        font-size:24px;
        color: #797979;
        font-family: ${css.fonts.bg_bold};
        display:block;
    }

    .results-wrapper {
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        position: relative;
        max-height: 100%;
    }

    @media (max-width: 768px) {
        .res-count {
            padding-top: 20px;
        }
    }
`

const Columns = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap:wrap;

    .section-name {
        font-size:16px;
        font-family: ${css.fonts.bg_medium};
        display:block;
        margin: 60px 0;
    }

    @media (max-width: 768px) {
        .section-name {
            margin: 40px 0;
        }
    }
`

const Column = styled.div`
    width: 30%;

    @media (max-width: 768px) {
        width:100%;
    }

    .item {
        margin-bottom: 40px;
        .title {
            font-size:24px;
        }
        .image {
            @media (max-width: 768px) {
                padding:0;
                height:190px;
            }
        }
        &.project, &.news {
            .title {
                font-size:24px;
                margin-bottom: 15px;
                display: inline-block;
                padding-bottom:0;
                border:none;
            }
            .meta {
                padding-top:15px;
                font-size:14px;
                color: #848484;
                span {
                    display:block;
                    color: #000000;
                }
            }
        }
        &.employee {
            .meta {
                padding-top:15px;
                span {
                    display:block;
                    color: #000000;
                    a {

                    }
                }
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/SearchResults.js